<template>
    <div class="tr m-promoPreviewDetails">
        <h6 class="typo--headline">Szczegóły</h6>
        <div
            class="
                    mp-promos__data
                    tr-data
                    is-column is-lg-row
                    row-cols-lg-5
                "
        >
            <div class="tr-data__cell">
                <span class="tr-data__dt">ID promocji</span>
                <span class="tr-data__dd">{{ id }}</span>
            </div>
            <div class="tr-data__cell">
                <span class="tr-data__dt">Czas trwania promocji</span>
                <span class="tr-data__dd">{{
                    durationDays | plurals('dzień', 'dni')
                }}</span>
            </div>
            <div class="tr-data__cell">
                <span class="tr-data__dt">{{ daysLeft.countText }}</span>
                <span class="tr-data__dd">{{ daysLeft.diff }}</span>
            </div>
            <div class="tr-data__cell">
                <span class="tr-data__dt">Limit użyć na paragonie</span>
                <span class="tr-data__dd">{{
                    usageLimitPerReceipt ? usageLimitPerReceipt : '-'
                }}</span>
            </div>
            <div class="tr-data__cell">
                <span class="tr-data__dt">Tekst na paragonie</span>
                <span
                    v-if="discountText"
                    @click.stop.prevent
                    class="tr-data__dd"
                    v-tooltip="discountText"
                    >pokaż</span
                >
                <a v-else class="tr-data__dd">-</a>
            </div>
        </div>
        <h6 class="typo--headline mt-2" v-if="productTriggers.length > 0">
            Wyzwalacze
        </h6>
        <div v-if="productTriggers.length > 0" class="mb-5">
            <promotion-preview-product
                v-for="(product, idx) in productTriggers"
                :key="idx"
                :product="product"
                :showMaxPrice="false"
            />
        </div>
        <h6 class="typo--headline mt-2" v-if="products.length > 0">
            Produkty promocyjne
        </h6>
        <div v-if="promotionalProducts">
            <promotion-preview-product
                v-for="(product, idx) in promotionalProducts"
                :key="idx"
                :product="product"
            />
            <template v-if="productSets.length > 0">
                <div v-if="type === 'Promo::MixPromotional'">
                    <div class="mt-3">
                        <h6 class="typo--headline mt-2">
                            Produkty wywołujące promocję
                        </h6>
                        <promotion-preview-product
                            v-for="(product,
                            idx) in promoMixPromotionalTriggersSet.product_set_dict_products"
                            :setWeight="
                                promoMixPromotionalTriggersSet.required_weight
                            "
                            :key="idx"
                            :product="product"
                        />
                    </div>
                    <div class="mt-3">
                        <h6 class="typo--headline mt-2">
                            Produkty promocyjne
                        </h6>
                        <promotion-preview-product
                            v-for="(product,
                            idx) in promoMixPromotionalProductsSet.product_set_dict_products"
                            :setWeight="
                                promoMixPromotionalProductsSet.required_weight
                            "
                            :key="idx"
                            :product="product"
                        />
                    </div>
                </div>
                <div v-else>
                    <h6 class="typo--headline mt-2">
                        Produkty promocyjne
                    </h6>
                    <div v-for="(productSet, idx) in productSets" :key="idx">
                        <promotion-preview-product
                            v-for="(product,
                            idx) in productSet.product_set_dict_products"
                            :setWeight="productSet.required_weight"
                            :key="idx"
                            :product="product"
                        />
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import PromotionPreviewProduct from '@/components/promotions/PromotionPreviewProduct'

export default {
    components: {
        PromotionPreviewProduct
    },
    props: {
        id: { type: Number, default: 0 },
        usageLimitPerReceipt: { type: Number, default: 0 },
        startAt: { type: String, default: '' },
        state: { type: String, default: '' },
        type: { type: String, default: '' },
        finishAt: { type: String, default: '' },
        discountText: { type: String, default: '' },
        products: { type: Array, default: () => [] },
        productSets: { type: Array, default: () => [] }
    },
    computed: {
        promoMixPromotionalTriggersSet() {
            if (this.type === 'Promo::MixPromotional') {
                return this.productSets.find(
                    set => set.type === 'ProductSet::Trigger'
                )
            } else {
                return null
            }
        },
        promoMixPromotionalProductsSet() {
            if (this.type === 'Promo::MixPromotional') {
                return this.productSets.find(
                    set => set.type === 'ProductSet::Promotional'
                )
            } else {
                return null
            }
        },
        promotionalProducts() {
            let products = []
            if (this.products.length > 0) {
                products = this.products.filter(el => el.promotional)
            }
            return products
        },
        productTriggers() {
            if (this.products.length > 0) {
                return this.products.filter(el => !el.promotional)
            } else {
                return []
            }
        },
        durationDays() {
            const start = moment(this.startAt)
            const end = moment(this.finishAt)
            return end.diff(start, 'days')
        },
        daysLeft() {
            return this.$store.getters.getDaysLeft({
                start_at: this.startAt,
                finish_at: this.finishAt,
                state: this.state
            })
        }
    }
}
</script>
